module.exports = __webpack_public_path__ + "img/advance_search.0fbe7b6d.png";